export const KIOSK_VISITORS_REQUESTED = 'KIOSK_VISITORS_REQUESTED';
export const KIOSK_VISITORS_SUCCESS = 'VISITORS_TO_VALIDATE_SUCCESS';
export const KIOSK_VISITORS_FAILED = 'KIOSK_VISITORS_FAILED';

export const ADD_KIOSK_VISITOR_REQUESTED = 'ADD_KIOSK_VISITOR_REQUESTED';
export const ADD_KIOSK_VISITOR_SUCCESS = 'ADD_KIOSK_VISITOR_SUCCESS';
export const ADD_KIOSK_VISITOR_FAILED = 'ADD_KIOSK_VISITOR_FAILED';

export const VALIDATE_KIOSK_VISITOR_REQUESTED = 'VALIDATE_KIOSK_VISITOR_REQUESTED';
export const VALIDATE_KIOSK_VISITOR_SUCCESS = 'VALIDATE_KIOSK_VISITOR_SUCCESS';
export const VALIDATE_KIOSK_VISITOR_FAILED = 'VALIDATE_KIOSK_VISITOR_FAILED';
